import { api as com, apiFuns } from "sw-hic";
let { get, post, put, del } = apiFuns;

const api = {
  PxyDb: {
    ...apiFuns.genStandard("pxyDb", "/api/md"),
    testSql:(para)=> post('/api/md/pxyDb/test', para),
  }
};

export default api;
